$(document).ready(function () {
  if($('.latestnews').length > 0) {
    const carouselNews = document.querySelector('.carousel-news');
    if (carouselNews) {
      new Glider(carouselNews, {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        draggable: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 1
            }
          }
        ]
      })
    }
  }
});


